"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconBookmark = _interopRequireDefault(require("../../../shared/icons/icon-bookmark.svg"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

var _EmbeddedVideo = _interopRequireDefault(require("../../../shared/components/EmbeddedVideo/EmbeddedVideo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
  TODO when adding Benefit List component:
    - Refactor generic Benefit Title & Body out as they will be used by non-key
    - Do something about the camelcase linter rule
*/

/* eslint-disable camelcase */
var KeyBenefits = function KeyBenefitsComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var key_benefits = pageData.key_benefits,
      key_benefits_ctas = pageData.key_benefits_ctas,
      key_benefits_media = pageData.key_benefits_media,
      key_benefits_media_link = pageData.key_benefits_media_link,
      key_benefits_title = pageData.key_benefits_title;

  var embeddedVideoExists = function embeddedVideoExists(key_benefits_media) {
    return key_benefits_media.provider_name && key_benefits_media.embed_url;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit-title-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "benefit-body__heading-2"
  }, dataClient.textToMarkdown(key_benefits_title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit-body-col"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "benefit-body-list benefit-body-list--bookmark"
  }, key_benefits.map(function (_ref2) {
    var key_benefit_title = _ref2.key_benefit_title,
        key_benefit_body = _ref2.key_benefit_body;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "benefit-body-list__item",
      key: dataClient.renderText(key_benefit_title)
    }, /*#__PURE__*/_react["default"].createElement(_iconBookmark["default"], {
      className: "benefit-body-list__bookmark-icon"
    }), /*#__PURE__*/_react["default"].createElement("h3", {
      className: "benefit-body__heading-3"
    }, dataClient.textToMarkdown(key_benefit_title)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "key-benefit-body__copy"
    }, dataClient.textToMarkdown(key_benefit_body)));
  })), key_benefits_ctas.map(function (_ref3) {
    var key_benefits_cta_link = _ref3.key_benefits_cta_link,
        key_benefits_cta_text = _ref3.key_benefits_cta_text,
        key_benefits_cta_type = _ref3.key_benefits_cta_type;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "benefit__cta-wrapper",
      key: key_benefits_cta_link.url
    }, /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
      href: key_benefits_cta_link.url,
      external: key_benefits_cta_link.target === '_blank',
      className: "benefit__cta-".concat(key_benefits_cta_type.toLowerCase())
    }, dataClient.textToMarkdown(key_benefits_cta_text)));
  }), embeddedVideoExists(key_benefits_media) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit__video-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_EmbeddedVideo["default"], {
    providerName: key_benefits_media.provider_name,
    url: key_benefits_media.embed_url
  })), key_benefits_media_link && /*#__PURE__*/_react["default"].createElement("div", {
    className: "benefit__video-link"
  }, dataClient.renderFullMarkup(key_benefits_media_link))))));
};

KeyBenefits.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = KeyBenefits;
exports["default"] = _default;